<template>
    <section class="section-outline" v-if="schools && schools.length">
        <mvtCollapse :disable="disableCollapse" :isActive="isActive">
            <template v-slot:header>
                <h2 class="f2 text-bold">
                    Schools
                    <sub class="sub">Public schools that serve {{ dpp.geo.address }}</sub>
                </h2>
            </template>
            <template v-slot:default>
                <div class="grid xs-grid-cols-1">
                    <div v-for="item in schools" :key="item.id">
                        <div class="school-card">
                            <div class="school-card-rate">
                                <template v-if="item.rating > 0">
                                    <span class="text-bold f4">{{ item.rating }}</span>/<span class="f6">10</span>
                                </template>
                                <template v-else>
                                    <span class="text-bold">N/A</span>
                                </template>
                            </div>
                            <div class="school-card-info">
                                <a class="link" :href="glb.appUrl + item.dspUrl">{{item.name}}</a>
                                <div>
                                    <span v-if="item.type">{{ item.type }}</span>
                                    <span v-else-if="item.levelCode === 'E'">Elementary</span>
                                    <span v-else-if="item.levelCode === 'M'">Middle</span>
                                    <span v-else-if="item.levelCode === 'H'">High</span>
                                    <span v-if="item.level">{{ `Grades ${item.level}` }}</span>
                                </div>
                                <a :href="`${glb.appUrl}${item.schoolDistrict.districtUrl}`" target="_blank" v-if="item.schoolDistrict && item.schoolDistrict.districtUrl">{{ item.schoolDistrict.name }}</a>
                                <div v-else-if="item.schoolDistrict && item.schoolDistrict.name">{{ item.schoolDistrict.name }}</div>
                            </div>
                            <button type="button" v-if="item.schoolDistrict"  @click="showSchoolDistrict(item.id)">See zoned homes <i class="icon-angle-right m-l-1"></i></button>
                        </div>
                    </div>
                    <div class="f7 text-gray m-t-2">
                        Source: GreatSchools.org © {{ new Date().getFullYear() }}. All rights reserved.
                    </div>
                </div>
            </template>
        </mvtCollapse>
    </section>
</template>
<script src="./property-school.js"></script>

<style lang="scss">
@use "./property-school.scss" as *;
</style>
